import React from 'react'

export const ErrorPage = () => {
  return (
    <div>ErrorPage</div>
  )
}

export default ErrorPage;